
var OSS_TEMPLATES_LIST = [
    'template/directives/vehicle-selector',
    'template/directives/error-message',
    'template/directives/header',
    'template/directives/vin-decode',
    'template/directives/horyzontal-scroll-container',
    'template/directives/no-time-slot',
    'template/directives/service-item',
    'template/directives/error-screen',
    'template/directives/recall',
    'template/directives/vehicle-alert',
    'template/directives/protection-plan',
    'template/directives/dropdown',
    'template/layouts/wellcome',
    'template/layouts/createcustomer-drive-train',
    'template/layouts/createcustomer-year',
    'template/layouts/schedule',
    'template/layouts/vehicle-check-health',
    'template/layouts/vehicle-updates',
    'template/layouts/createcustomer-model',
    'template/layouts/dealer-recommended',
    'template/layouts/createcustomer-engine',
    'template/layouts/customer-concerns',
    'template/layouts/appointment-summary',
    'template/layouts/factory-required',
    'template/layouts/book-appointment',
    'template/layouts/search-result',
    'template/layouts/confirmation',
    'template/layouts/createcustomer-transmission',
    'template/layouts/createcustomer-manufacturer',
    'template/layouts/createcustomer',
    'template/layouts/createcustomer-overview',
    'template/layouts/services-required',
    'template/errorscreens/booking-error',
    'template/errorscreens/can-not-get-avaliable-item',
    'template/errorscreens/can-not-get-avaliable-time',
    'template/errorscreens/connection-lost',
    'template/errorscreens/generic-error',
    'template/errorscreens/search-error',
    'template/directives/service-contract-warning'
];

module.exports = OSS_TEMPLATES_LIST;
